import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import ContactUs from '../../molecules/contact-us/contact-us';
import './micro-payment.m.css';

const PaymentError = props => {
  const error = get(props.errorResponse, ['error', 'message', 'payment.from_gateway'], null);
  const errorMsg = error ? error[0].message : null;
  const insufficientBalance = errorMsg === 'wallet has insufficient balance';

  return (
    <div data-testid="payment-error" id="payment-error" styleName="story-subscribe-wrap">
      <div styleName="story-subscribe">
        <div styleName="align">
          <h3 styleName="subscribe-headline">
            {insufficientBalance ? 'Oops! Insufficient Balance.' : 'Oops! There is an error.'}
          </h3>
          <p styleName="subscribe-summary error-icon">
            {insufficientBalance
              ? 'Please refill your Paytm wallet to continue.'
              : 'We are unable to process your payment'}
          </p>
          <div styleName="subscribe-buttons">
            <button onClick={props.tryAgain} styleName="paywall-button try-again-btn">
              Try Again
            </button>
          </div>
          <span styleName="paywall-footer">
            Questions?{' '}
            <a
              href="javascript:void(0)"
              styleName="paywall-footer-link"
              onClick={props.contactHandler}
            >
              Contact Us
            </a>
          </span>
        </div>
        {props.isContactUsOpen && <ContactUs onClose={props.closeContactUs} />}
      </div>
    </div>
  );
};

PaymentError.propTypes = {
  tryAgain: PropTypes.func.isRequired,
  errorResponse: PropTypes.objectOf(PropTypes.any).isRequired,
  isContactUsOpen: PropTypes.bool.isRequired,
  closeContactUs: PropTypes.func.isRequired,
  contactHandler: PropTypes.func.isRequired
};
export default PaymentError;
